import { createFileRoute } from '@tanstack/react-router'
import ProjectTicketsPage from '@/spa/pages/projects/ProjectTicketsPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/tickets')({
  component: ProjectTicketsPage,
  errorComponent: routeErrorComponent,
})
